import React from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faFileExcel,
  faFileImport,
  faEgg,
} from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import ProduccionHuevosTable from "./ProduccionHuevosTable/ProduccionHuevosTable";
import { useShoppingContext } from "../../../context/ShoppingContext";

const ProduccionHuevos = () => {
  const {
    setShowAddProduccion,
    produccionHuevos,
    showAddProduccion,
    aves,
    selectedAve, 
    setProduccionHuevos,
    setDropzone,
  } = useShoppingContext();

  const exportToExcel = () => {
    const workbook = XLSX.utils.book_new();

    aves.forEach((ave) => {
      const loteProduccion = produccionHuevos.filter(
        (produccion) => produccion.id_ave === ave.id
      );

      if (loteProduccion.length > 0) {
        const dataNumerica = loteProduccion.map((produccion) => ({
          Fecha: formatDateToISO(produccion.fecha),
          Total: produccion.total,
          Comercial: produccion.comerciales,
          Pardo: produccion.pardo,
          Sucio: produccion.sucio,
          Blanco: produccion.blanco,
          "Doble Yema": produccion.doble_yema,
          Quiñado: produccion.quiñado,
          Roto: produccion.roto,
        }));

        const worksheetNumerica = XLSX.utils.json_to_sheet(dataNumerica);
        XLSX.utils.book_append_sheet(
          workbook,
          worksheetNumerica,
          `Lote ${ave.nombre} - Datos`
        );

        const totalHuevos = loteProduccion.reduce(
          (acc, produccion) => acc + produccion.total,
          0
        );
        const porcentajes = {
          Comercial: (
            (loteProduccion.reduce(
              (acc, produccion) => acc + produccion.comerciales,
              0
            ) /
              totalHuevos) *
            100
          ).toFixed(2),
          Pardo: (
            (loteProduccion.reduce(
              (acc, produccion) => acc + produccion.pardo,
              0
            ) /
              totalHuevos) *
            100
          ).toFixed(2),
          Sucio: (
            (loteProduccion.reduce(
              (acc, produccion) => acc + produccion.sucio,
              0
            ) /
              totalHuevos) *
            100
          ).toFixed(2),
          Blanco: (
            (loteProduccion.reduce(
              (acc, produccion) => acc + produccion.blanco,
              0
            ) /
              totalHuevos) *
            100
          ).toFixed(2),
          "Doble Yema": (
            (loteProduccion.reduce(
              (acc, produccion) => acc + produccion.doble_yema,
              0
            ) /
              totalHuevos) *
            100
          ).toFixed(2),
          Quiñado: (
            (loteProduccion.reduce(
              (acc, produccion) => acc + produccion.quiñado,
              0
            ) /
              totalHuevos) *
            100
          ).toFixed(2),
          Roto: (
            (loteProduccion.reduce(
              (acc, produccion) => acc + produccion.roto,
              0
            ) /
              totalHuevos) *
            100
          ).toFixed(2),
        };

        const dataPorcentajes = Object.keys(porcentajes).map((tipo) => ({
          Tipo: tipo,
          Porcentaje: `${porcentajes[tipo]}%`,
        }));

        const worksheetPorcentajes = XLSX.utils.json_to_sheet(dataPorcentajes);
        XLSX.utils.book_append_sheet(
          workbook,
          worksheetPorcentajes,
          `Lote ${ave.nombre} - Porcentajes`
        );
      }
    });

    XLSX.writeFile(workbook, "produccion_huevos_lotes.xlsx");
  };

  // Función para manejar la carga del archivo Excel
const handleFileUpload = async (file) => {
  const reader = new FileReader();
  reader.onload = async (event) => {
    const binaryStr = event.target.result;
    const workbook = XLSX.read(binaryStr, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    const data = XLSX.utils.sheet_to_json(sheet);

    if (validateFile(data)) {
      try {
        // Hacer un post con los datos validados
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/produccion-huevos/import`,
          data
        );
        setProduccionHuevos((prevProduccionHuevos) => [
          ...prevProduccionHuevos,
          ...response.data,
        ]);
        console.log("Datos importados correctamente:", response.data);
      } catch (error) {
        console.error("Error al importar datos:", error);
      }
    } else {
      console.error("Archivo inválido");
    }
  };
  reader.readAsBinaryString(file);
};

// Función para validar el archivo subido
const validateFile = (data) => {
  // Verificar que el archivo tenga las columnas necesarias
  const requiredFields = [
    "Fecha",
    "Lote",
    "Comerciales",
    "Pardo",
    "Sucio",
    "Blanco",
    "Doble Yema",
    "Quiñado",
    "Roto",
    "Total",
    "GranjaId",
  ];

  const isValid = data.every((row) =>
    requiredFields.every((field) => field in row)
  );

  if (!isValid) {
    alert("El archivo no tiene el formato correcto.");
  }

  return isValid;
};

// Función para descargar una plantilla de Excel
const downloadTemplate = () => {
  const workbook = XLSX.utils.book_new();
  const dataTemplate = [
    {
      Fecha: "dd-MM-yyyy",
      Lote: "Ejemplo: Lote 1",
      Comerciales: 0,
      Pardo: 0,
      Sucio: 0,
      Blanco: 0,
      "Doble Yema": 0,
      Quiñado: 0,
      Roto: 0,
      Total: 0,
      GranjaId: 0,
    },
  ];

  const worksheetTemplate = XLSX.utils.json_to_sheet(dataTemplate);
  XLSX.utils.book_append_sheet(
    workbook,
    worksheetTemplate,
    "ProduccionTemplate"
  );

  XLSX.writeFile(workbook, "produccion_template.xlsx");
};


  const formatDateToISO = (date) => {
    const d = new Date(date);
    d.setUTCHours(0, 0, 0, 0);
    return d.toISOString().split("T")[0];
  };

  // Filtrar la producción de huevos por el ave seleccionada
  const filteredProduccionHuevos = selectedAve
    ? produccionHuevos.filter(
        (produccion) => produccion.id_ave === selectedAve.id
      )
    : [];

  const handleDeleteAll = () => {
    if (
      window.confirm(
        "¿Estás seguro de que deseas eliminar todos los registros de producción de huevos?"
      )
    ) {
      axios
        .delete(`${process.env.REACT_APP_API_URL}/produccion-huevos`)
        .then(() => {
          setProduccionHuevos([]);
          console.log(
            "Todos los registros de producción de huevos han sido eliminados"
          );
        })
        .catch((error) => {
          console.error(
            "Error al eliminar todos los registros de producción de huevos:",
            error
          );
        });
    }
  };

  return (
    <div className="container">
      <div className="flex">
        <button
          className="btn btn-green control-action-btn"
          onClick={() => setShowAddProduccion(!showAddProduccion)}
        >
          Recolectar Huevos <FontAwesomeIcon icon={faEgg} />
        </button>
      </div>
      {filteredProduccionHuevos.length === 0 && (
        <div className="flex">
          <button className="btn-warning" onClick={setDropzone}>
            <FontAwesomeIcon icon={faFileImport} /> Import{" "}
          </button>
        </div>
      )}
      {filteredProduccionHuevos.length === 0 ? (
        <></>
      ) : (
        <div className="control-secondary-btns">
          <button className="btn btn-warning" onClick={setDropzone}>
            <FontAwesomeIcon icon={faFileImport} /> Import{" "}
          </button>
          <button className="btn btn-success" onClick={exportToExcel}>
            <FontAwesomeIcon icon={faFileExcel} /> Export{" "}
          </button>
          <button className="btn btn-danger" onClick={handleDeleteAll}>
            <FontAwesomeIcon icon={faTrash} /> All{" "}
          </button>
        </div>
      )}
  
      <div className="main-content">
        <div className="table-section">
          {!filteredProduccionHuevos.length ? (
            <div className="empty-section">
              <p className="title-bold">
                ¡No has agregado recolección de huevos todavía!
              </p>
              <p>
                Empieza a llevar un control eficiente de la producción de tu
                granja. Registra la recolección diaria de huevos para monitorear
                el rendimiento de tus aves y optimizar la producción. ¡Haz que
                cada huevo cuente y lleva tu granja al siguiente nivel con
                nuestra app!
              </p>
            </div>
          ) : (
            <ProduccionHuevosTable produccionHuevos={filteredProduccionHuevos} />
          )}
        </div>
      </div>
    </div>
  );
  
};

export default ProduccionHuevos;
